import { render, staticRenderFns } from "./CatalogEditPage.vue?vue&type=template&id=96ac1546&"
import script from "./CatalogEditPage.vue?vue&type=script&lang=js&"
export * from "./CatalogEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96ac1546')) {
      api.createRecord('96ac1546', component.options)
    } else {
      api.reload('96ac1546', component.options)
    }
    module.hot.accept("./CatalogEditPage.vue?vue&type=template&id=96ac1546&", function () {
      api.rerender('96ac1546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/CatalogEditPage.vue"
export default component.exports